module.exports = __webpack_public_path__ + "static/img/splbBgc.e8100291.png";